/**
 * Configuración centralizada de API URL
 * Detecta automáticamente el entorno y usa la URL apropiada
 */

/**
 * Obtiene la URL base de la API según el entorno
 * - En localhost: usa REACT_APP_API_URL o http://localhost:4004
 * - En producción: usa REACT_APP_API_URL o el mismo dominio actual
 */
export const getApiUrl = () => {
  const isLocalhost = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';
  
  if (isLocalhost) {
    // Desarrollo local
    return (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');
  } else {
    // Producción: usar REACT_APP_API_URL si está definida, sino usar el mismo dominio
    // Esto permite que las variables de entorno sobreescriban el comportamiento
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL.replace(/\/$/, '');
    }
    return window.location.origin;
  }
};

/**
 * URL de la API (remover barra final si existe)
 */
export const API_URL = getApiUrl();

/**
 * Construir URL completa para un endpoint
 * @param {string} endpoint - Endpoint de la API (ej: '/api/beneficios')
 * @returns {string} URL completa
 */
export const buildApiUrl = (endpoint) => {
  const base = getApiUrl();
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${base}${path}`;
};

/**
 * Construir URL completa para un archivo estático
 * @param {string} filePath - Ruta del archivo (ej: '/beneficios-files/beneficio1.jpg')
 * @returns {string} URL completa
 */
export const buildFileUrl = (filePath) => {
  if (filePath.startsWith('http')) {
    return filePath; // Ya es URL completa
  }
  const base = getApiUrl();
  const path = filePath.startsWith('/') ? filePath : `/${filePath}`;
  return `${base}${path}`;
};

export default API_URL;
